import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import ChatWidget from "@/components/ChatWidget";
import Home from "@/pages/Home";
import ReviewsPage from "@/pages/ReviewsPage";
import "@/App.css";
import "@/direction.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/reviews" element={<ReviewsPage />} />
        </Routes>
      </BrowserRouter>
      <ChatWidget />
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}

export default App;
